export default __webpack_public_path__ + "static/media/untitled500x763.fb243467.jpg";